var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7143 6.67253H3.85714L8.08714 2.2827C8.20765 2.15866 8.3033 2.01109 8.36858 1.84849C8.43385 1.68589 8.46746 1.51149 8.46746 1.33535C8.46746 1.15921 8.43385 0.984809 8.36858 0.822213C8.3033 0.659617 8.20765 0.512043 8.08714 0.388003C7.84625 0.139489 7.52038 0 7.18071 0C6.84105 0 6.51518 0.139489 6.27429 0.388003L0.758572 6.12547C0.275673 6.62363 0.00287073 7.30021 0 8.00682C0.00625704 8.7088 0.2788 9.37995 0.758572 9.87484L6.27429 15.6123C6.39416 15.7358 6.53631 15.8337 6.69262 15.9002C6.84892 15.9667 7.01632 16.0006 7.18526 16C7.3542 15.9994 7.52136 15.9642 7.67721 15.8966C7.83306 15.8289 7.97454 15.73 8.09357 15.6056C8.21261 15.4812 8.30686 15.3337 8.37096 15.1715C8.43506 15.0093 8.46774 14.8356 8.46714 14.6602C8.46655 14.4849 8.43268 14.3114 8.36748 14.1497C8.30228 13.988 8.20702 13.8411 8.08714 13.7176L3.85714 9.34112H16.7143C17.0553 9.34112 17.3823 9.20054 17.6234 8.95031C17.8645 8.70008 18 8.3607 18 8.00682C18 7.65295 17.8645 7.31356 17.6234 7.06334C17.3823 6.81311 17.0553 6.67253 16.7143 6.67253Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDark);
export default __webpack_public_path__ + "static/media/arrow-dark.00bb93009981919245237b853957ab2b.svg";
export { ForwardRef as ReactComponent };